import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPregnancy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12.8081C15 14.465 13.6569 15.8081 12 15.8081C10.3431 15.8081 9 14.465 9 12.8081C9 11.1513 10.3431 9.80811 12 9.80811C13.6569 9.80811 15 11.1513 15 12.8081Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 5.80811C8.13401 5.80811 5 8.94211 5 12.8081C5 13.1069 5.01867 13.4009 5.05479 13.6891C5.1235 14.237 4.73497 14.737 4.18697 14.8057C3.63898 14.8744 3.13904 14.4859 3.07033 13.9379C3.02388 13.5674 3 13.1903 3 12.8081C3 7.83754 7.02944 3.80811 12 3.80811C16.9706 3.80811 21 7.83754 21 12.8081C21 17.7787 16.9706 21.8081 12 21.8081C11.2354 21.8081 10.4918 21.7125 9.7809 21.5322C9.38438 21.4316 8.99834 21.3047 8.62478 21.1535C8.11285 20.9463 7.86584 20.3633 8.07306 19.8514C8.28029 19.3394 8.86328 19.0924 9.37522 19.2997C9.66523 19.417 9.96488 19.5155 10.2727 19.5936C10.8241 19.7335 11.4026 19.8081 12 19.8081C15.866 19.8081 19 16.6741 19 12.8081C19 8.94211 15.866 5.80811 12 5.80811Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 17.4747L5.38462 16.8081L4.467 18.9259C4.35813 19.1772 4.15538 19.3661 3.90977 19.4452L3.00605 19.7363C2.71768 19.8292 2.49137 20.0723 2.40317 20.3839L2 21.8081L2.62246 20.6467C2.76673 20.3776 3.02113 20.1994 3.30692 20.1674L4.40619 20.0442C4.7196 20.009 4.99311 19.7986 5.12699 19.4896L6 17.4747Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.01675 15.6777C5.76714 14.9273 7.33055 14.4588 8.0059 15.1342C8.68125 15.8095 8.21281 17.3729 7.46242 18.1233C6.71203 18.8737 5.42036 19.0704 4.74501 18.3951C4.06966 17.7197 4.26636 16.428 5.01675 15.6777Z",
			fill: "currentColor"
		})
	]
});
export default SvgPregnancy;
